export default __webpack_public_path__ + "static/media/generic-org.c22d004c.png";